export default __webpack_public_path__ + "images/2cfd9fe7d7f1b2625cebd6dd3f4d4143-PH_Top_Desktop.jpg";